import React, { useState } from "react";
import AccountsTree from "../components/ui/treesData/AccountsTree";
import { useTranslation } from "react-i18next";
import { CardHeadeWithActions, MwButton } from "../components/ui";
import { CenterAccountMngPop } from "../popups/CenterAccountMngPop";
import AccountCenterContext from "../utils/CostCenterAccHelper";
import axios from "axios";
import { useTenant } from "../hooks";
import { useContext } from "react";

export const AccountCenter = () => {
  const [t] = useTranslation("global");
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingChild , setloadingChild] = useState(false);
  const [code, setCode] = useState(null);
  const [actionData, setActionData] = useState({
    mode: null,
    parentId: null,
    account: null,
  });
  const BaseUrl = process.env.REACT_APP_INV_API_SERVER_BASE_URL;
  const { tenantId, companySelected, branchSelected } = useTenant();
  const { editAccount, deleteAccount } = useContext(
    AccountCenterContext,
  );
  const GetCode = async () => {
    if (!tenantId || !companySelected?.value || !branchSelected?.value) {
      console.warn("Missing tenant/company/branch while generating account code", {
        tenantId,
        companyId: companySelected?.value,
        branchId: branchSelected?.value,
      });
      return null;
    }

    try {
      setLoading(true);
      const code = await axios.post(
        `${BaseUrl}/tree-cost-center/genAccountNo/0`,
        {
          tenant_id: tenantId,
          company_id: companySelected?.value,
          branch_id: branchSelected?.value,
        },
      );
      return code?.data?.data;
    } catch (err) {
      console.error(
        "Failed to generate cost center account code",
        err?.response?.data || err?.message || err,
      );
      return null;
    } finally {
      setLoading(false);
    }
  };
  return (
    <section className="p-2 grid w-full grid-cols-1 h-full items-start justify-start">
      <div className="flex flex-col gap-4">
        <CardHeadeWithActions
          title={t("menu.accountCenter")}
          icon={"/assets/icons/manage.svg"}
        >
          <MwButton
            classNameCustom="w-max  text-white bg-[#261759] hover:bg-[#463977] "
            children={t("common.add")}
            onClick={async () => {
              setCode(null);
              setIsOpen(true);
              const newAccountNo = await GetCode();
              setCode(newAccountNo);
              setActionData({
                mode: "add",
                parentId: null,
                accountType: "primary",
                account: null,
              });
            }}
            type="newBtn"
          />
        </CardHeadeWithActions>
        <div className="min-w-[100%]  h-auto">
          <AccountsTree
            deleteAccount={deleteAccount}
            editAccount={editAccount}
            loadingChild={loadingChild}
            setLoadingchild={setloadingChild}
            setCode={setCode}
            loading={loading}
            setIsOpen={setIsOpen}
            setActionData={setActionData}
          />
        </div>
      </div>

      <CenterAccountMngPop
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        actionData={actionData}
        code={code}
        loading={loading}
        loadingChild={loadingChild}
      />
    </section>
  );
};
